import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_text = _resolveComponent("vue-text")!
  const _component_vue_form_group = _resolveComponent("vue-form-group")!
  const _component_vue_thumbnail = _resolveComponent("vue-thumbnail")!
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_vue_rich_editor = _resolveComponent("vue-rich-editor")!
  const _component_vue_checkbox = _resolveComponent("vue-checkbox")!
  const _component_vue_button = _resolveComponent("vue-button")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createVNode(_component_vue_form_group, {
      errors: $data.errors['email'],
      label: "Email",
      help: "Nie wysyłamy spamu! Obiecujemy."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_text, {
          name: "email",
          modelValue: $options.applicationSync.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($options.applicationSync.email) = $event)),
          "is-invalid": 'email' in $data.errors
        }, null, 8 /* PROPS */, ["modelValue", "is-invalid"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["errors"]),
    _createVNode(_component_vue_form_group, {
      errors: $data.errors['name'],
      label: "Imię i nazwisko"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_text, {
          name: "name",
          modelValue: $options.applicationSync.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($options.applicationSync.name) = $event)),
          "is-invalid": 'name' in $data.errors
        }, null, 8 /* PROPS */, ["modelValue", "is-invalid"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["errors"]),
    _createVNode(_component_vue_form_group, {
      errors: $data.errors['phone'],
      label: "Numer telefonu",
      help: "Podanie numeru telefonu nie jest obowiązkowe, ale pozwoli na szybki kontakt."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_text, {
          name: "phone",
          modelValue: $options.applicationSync.phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($options.applicationSync.phone) = $event)),
          "is-invalid": 'phone' in $data.errors
        }, null, 8 /* PROPS */, ["modelValue", "is-invalid"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["errors"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("label", { class: "col-form-label" }, "CV/Resume", -1 /* HOISTED */)),
      _createVNode(_component_vue_thumbnail, {
        url: $options.applicationSync.cv,
        "upload-url": "/Praca/Upload",
        name: "cv",
        onUpload: $options.addAsset,
        onDelete: $options.deleteAsset,
        class: "w-25"
      }, null, 8 /* PROPS */, ["url", "onUpload", "onDelete"]),
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "form-text" }, "CV/résumé z rozszerzeniem *.pdf, *.doc, *.docx lub *.rtf. Maksymalnie 5 MB.", -1 /* HOISTED */))
    ]),
    _createVNode(_component_vue_form_group, {
      errors: $data.errors['github'],
      label: "Konto Github",
      class: "github"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_text, {
          name: "github",
          modelValue: $options.applicationSync.github,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($options.applicationSync.github) = $event)),
          "is-invalid": 'github' in $data.errors
        }, null, 8 /* PROPS */, ["modelValue", "is-invalid"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["errors"]),
    _createVNode(_component_vue_form_group, {
      errors: $data.errors['dismissal_period'],
      label: "Obecny okres wypowiedzenia"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_select, {
          modelValue: $options.applicationSync.dismissal_period,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($options.applicationSync.dismissal_period) = $event)),
          options: $options.dismissalPeriod,
          placeholder: "Nie określono"
        }, null, 8 /* PROPS */, ["modelValue", "options"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["errors"]),
    _createVNode(_component_vue_form_group, {
      errors: $data.errors['text'],
      label: "Wiadomość dla pracodawcy/zleceniodawcy",
      help: "Taką wiadomość otrzyma osoba, która wystawiła ogłoszenie"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_rich_editor, {
          modelValue: $options.applicationSync.text,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($options.applicationSync.text) = $event))
        }, null, 8 /* PROPS */, ["modelValue"]),
        _withDirectives(_createElementVNode("input", {
          type: "hidden",
          name: "text",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($options.applicationSync.text) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $options.applicationSync.text]
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["errors"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_vue_checkbox, {
          modelValue: $options.applicationSync.remember,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($options.applicationSync.remember) = $event)),
          id: "enable-invoice",
          class: "me-2"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          class: "custom-control-label",
          for: "enable-invoice"
        }, " Zapamiętaj dane podane w formularzu ", -1 /* HOISTED */))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vue_button, {
        disabled: $data.isProcessing,
        onClick: $options.submitForm,
        class: "btn btn-primary"
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode(" Wyślij ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ])
  ]))
}